const getActionsApiBaseUrl = (): string =>
    (import.meta.env.VITE_ACTIONS_BASE_URL || 'http://localhost:8080').replace(/\/+$/, '');

export default getActionsApiBaseUrl;
